import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import visualsService from "../../services/visualsService";


export const fetchRiskTimeline = createAsyncThunk(
  "visuals/fetchRiskTimeline",
  async (_, { rejectWithValue }) => {
    try {
      const response = await visualsService.getRiskGraphTimeline();
      // Extracts the 'graph' array from your response payload
      return response?.data?.graph ?? [];
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch timeline");
    }
  }
);

export const fetchVisualChartData = createAsyncThunk(
  'visual/fetchChartData',
  async (_, { rejectWithValue }) => {
    try {
      // Replace with your actual API endpoint URL
      const response = await visualsService.getdepartmentGraphData();
    //   console.log("fetchchartdata",response.data)
      return response; // This returns the full object { data: { data: [...] }, success: true }
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch visual chart data');
    }
  }
);

export const fetchIdentityDistributiontData = createAsyncThunk(
  'visual/fetchIdentityDistributiontData',
  async (_, { rejectWithValue }) => {
    try {
      // Replace with your actual API endpoint URL
      const response = await visualsService.getidentitydistributionData();
      // console.log("fetchchartdata",response.data)
      return response; // This returns the full object { data: { data: [...] }, success: true }
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch visual chart data');
    }
  }
);

const visualsSlice = createSlice({
  name: "visuals",
  initialState: {
    timeline: [],
    loading: false,
    error: null,
    chartDataPayload: null,
    isChartLoading: false,
    chartError: null,

    distributionData: null,
    distributionLoading: false,
    distributionError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRiskTimeline.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRiskTimeline.fulfilled, (state, action) => {
        state.loading = false;
        state.timeline = action.payload;
      })
      .addCase(fetchRiskTimeline.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchVisualChartData.pending, (state) => {
        state.isChartLoading = true;
        state.chartError = null;
      })
      .addCase(fetchVisualChartData.fulfilled, (state, action) => {
        state.isChartLoading = false;
        state.chartDataPayload = action.payload; // Saves the API structure safely
      })
      .addCase(fetchVisualChartData.rejected, (state, action) => {
        state.isChartLoading = false;
        state.chartError = action.payload;
      })
      .addCase(fetchIdentityDistributiontData.pending, (state) => {
        state.distributionLoading = true;
        state.distributionError = null;
      })
      .addCase(fetchIdentityDistributiontData.fulfilled, (state, action) => {
        state.distributionLoading = false;
        state.distributionData = action.payload; // Saves your complete API payload response object
      })
      .addCase(fetchIdentityDistributiontData.rejected, (state, action) => {
        state.distributionLoading = false;
        state.distributionError = action.payload;
      });
  },
});

export default visualsSlice.reducer;


// src/redux/slices/mfaSlice.js

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const mfaSlice = createSlice({
  name: "mfaDept",
  initialState,
  reducers: {
    mfaDeptRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    mfaDeptSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.error = null;
    },
    mfaDeptFailure: (state, action) => {
      state.loading = false;
      state.data = null;
      state.error = action.payload;
    },
    mfaDeptReset: () => initialState,
  },
});

// Export actions (auto-generated by createSlice)
export const {
  mfaDeptRequest,
  mfaDeptSuccess,
  mfaDeptFailure,
  mfaDeptReset,
} = mfaSlice.actions;

// Export reducer
export const mfaReducer = mfaSlice.reducer;